module.exports = __webpack_public_path__ + "img/3.6604c674.png";